import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import '../shared/Navbar.css';

function DeliveryNavbar() {
  const [menuAbierto, setMenuAbierto] = useState(false);
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    setMenuAbierto(false);
    navigate('/login-delivery'); // Redirigimos al login de repartidor
  };

  return (
    <nav className="navbar navbar-delivery">
      <h2 className="navbar-logo">Clavelina Repartidor</h2>

      <div className="hamburguesa" onClick={() => setMenuAbierto(!menuAbierto)}>
        ☰
      </div>

      <ul className={`navbar-links ${menuAbierto ? 'activo' : ''}`}>
        <li onClick={() => { navigate('/delivery'); setMenuAbierto(false); }}>Pedidos</li>
        <li onClick={() => { navigate('/delivery/mis-entregas'); setMenuAbierto(false); }}>Mis Entregas</li>
        
        <li className="user-name">Repartidor: <strong>{user?.nombre}</strong></li>
        
        <li onClick={handleLogout} className="logout-btn">Salir</li>
      </ul>
    </nav>
  );
}

export default DeliveryNavbar;